import axiosInstance from 'api/axiosInstance';
import { URL_CANDISPATCH_CREATE_ADDRESS } from 'constants/urls';

const createAddress = async (addressData: Record<string, unknown>) => {
  try {
    const { data } = await axiosInstance({
      method: 'POST',
      url: URL_CANDISPATCH_CREATE_ADDRESS,
      data: { payload: addressData },
      headers: { 'Content-Type': 'application/json;charset=UTF-8' },
    });
    return data;
  } catch (error) {
    console.error('[createAddress] Failed:', error);
    throw error;
  }
};

export default createAddress;
